defineDs('DanskeSpil/Framework/PlayerAccountManagement/Scripts/Helpers/Utils', [
  'Shared/Framework/Mithril/Scripts/Core/Mithril',
  'Shared/Framework/Mithril/Scripts/Helpers/Utils',
  'Shared/Framework/Mithril/Scripts/Helpers/QuickLink',
  'DanskeSpil/Domain/Authentification/Scripts/LoginSSO',
  'Shared/Framework/Mithril/Scripts/Templates/Overlay',
  'DanskeSpil/Framework/PlayerAccountManagement/Scripts/Templates/ModalDialog',
  'DanskeSpil/Framework/PlayerAccountManagement/Scripts/Helpers/Dictionary'
], function (m, Utils, QuickLink, LoginSSO, Overlay, ModalDialog, Dictionary) {

  var defaultReceiptRedirect = new QuickLink('/AccountOverview').get;

  // Functions:
  var hasObjectProperty = function (obj, path, options) {
    var args = path.split('.');
    var params = Utils.extend(true, {
      getValue: false
    }, options);

    for (var i = 0; i < args.length; i++) {
      if (!obj || !obj.hasOwnProperty(args[i])) {
        return false;
      }
      obj = obj[args[i]];
    }
    if (params.getValue) {
      return obj;
    } else {
      return true;
    }
  };

  var populateUrlWithAssertionIdAndLoginId = function (url, callback) {
    LoginSSO.relay(function (data) {
      if (data.assertionId && data.loginId) {
        var assertionId = data.assertionId;
        var loginId = data.loginId;
        var initialQueryCharacter = url.indexOf('?') > -1 ? '&' : '?';
        var finalUrl = url + initialQueryCharacter + 'josso_assertion_id=' + assertionId + '&loginId=' + encodeURIComponent(loginId);
        callback(finalUrl);
      } else {
        Dictionary.ready.then(function () {
          var d = Dictionary.get.bind({ prefix: 'GeneralErrorHandler/' });
          var dialogcontent = [
            m('h1', d('Headline')),
            m('p', d('BodyText'))
          ];
          var overlay = new Overlay(ModalDialog(dialogcontent, {
            buttons: [
              {
                text: d('ButtonText'), callback: function (close) {
                  close();
                }
              }
            ]
          }));
          overlay.show();
        });
      }
    });
  };

  var getValidAppRedirectUrl = function () {
    var url = getParameter('signupSuccessUrl') || getParameter('returnUrl') || getDefaultRedirectUrl();
    var decodedUrl = decodeURIComponent(url);

    if (isAppUrl(decodedUrl)) {
      repopulateUrlWithAssertionIdAndLoginId(decodedUrl, function (populatedUrl) {
        window.location.href = populatedUrl;
      });

    } else {
      window.location.href = decodedUrl;
    }
  };

  var repopulateUrlWithAssertionIdAndLoginId = function (url, callback) {
    LoginSSO.relay(function (data) {
      if (data.assertionId && data.loginId) {
        var assertionId = data.assertionId;
        var loginId = data.loginId;
        var initialQueryCharacter = url.indexOf('?') > -1 ? '&' : '?';

        var currentJossoAssertionId = getParameter('josso_assertion_id');
        var currentLoginId = getParameter('loginId');

        var finalUrl;
        if (currentJossoAssertionId && currentLoginId) {
          url.replace(currentJossoAssertionId, assertionId);
          url.replace(currentLoginId, loginId);
          finalUrl = url;
        } else if (currentJossoAssertionId && !currentLoginId) {
          url.replace(currentJossoAssertionId, assertionId);
          finalUrl = url + '&loginId=' + encodeURIComponent(loginId);
        } else if (currentLoginId && !currentJossoAssertionId) {
          url.replace(currentLoginId, loginId);
          finalUrl = url + '&josso_assertion_id=' + assertionId;
        } else {
          finalUrl = url + initialQueryCharacter + 'josso_assertion_id=' + assertionId + '&loginId=' + encodeURIComponent(loginId);
        }
        callback(finalUrl);
      } else {
        Dictionary.ready.then(function () {
          var d = Dictionary.get.bind({ prefix: 'GeneralErrorHandler/' });
          var dialogcontent = [
            m('h1', d('Headline')),
            m('p', d('BodyText'))
          ];
          var overlay = new Overlay(ModalDialog(dialogcontent, {
            buttons: [
              {
                text: d('ButtonText'), callback: function (close) {
                  close();
                }
              }
            ]
          }));
          overlay.show();
        });
      }
    });
  };

  var checkEncodeURI = function (str) {
    return /\%/i.test(str); // eslint-disable-line no-useless-escape
  };

  var isAppUrl = function (url) {
    var matches = [
      'app://dummy'
    ];
    return matches.some(function (match) {
      return url.indexOf(match) > -1;
    });
  };

  var urlContainsLoginInformation = function (url) {
    var matches = [
      'assertionId',
      'loginId'
    ];
    return matches.every(function (match) {
      return url.toLowerCase().indexOf(match.toLowerCase()) > -1;
    });
  };

  var getDefaultRedirectUrl = function () {
    return Utils.cookie(DS.Config.CONTEXT + 'currentBrandURL') || defaultReceiptRedirect('ReceiptFallback').Url || window.location.origin;
  };

  var getRedirectUrlWithDsApplicationIdAndReturnUrl = function (url) {
    var dsApplicationId = getParameter('dsApplicationId') || (window.dsApplicationConfig && window.dsApplicationConfig.ApplicationId);
    var returnUrl = getParameter('returnUrl');
    var hash = '';

    // Check for hash values and store temp
    if (url.indexOf('#') >= 0) {
      hash = url.substr(url.indexOf('#'), url.length);
      url = url.substr(0, url.indexOf('#'));
    }

    // Check if other query params exists before appending returnUrl
    if (returnUrl) {
      url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'returnUrl=' + returnUrl;
    }

    // Check if other query params exists before append dsApplicationId
    if (dsApplicationId !== undefined) {
      url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'dsApplicationId=' + dsApplicationId;
    }

    // Reappend hash value if exist.
    if (hash.length > 0) {
      url = url + hash;
    }

    return url;
  };

  var getParameter = function (key, queryString) {
    // if queryString not defined, use current location URL
    if (typeof queryString === 'undefined') {
      queryString = location.search.substring(1);
    }

    if (queryString.charAt(0) === '?') {
      queryString = queryString.substring(1);
    }

    var params = queryString.split('&');
    for (var i = 0; i < params.length; i++) {
      var keyVal = params[i].split('=');
      if (keyVal.length > 1 && keyVal[0].toLowerCase() == key.toLowerCase()) {
        return keyVal[1];
      }
    }
    return null;
  };

  var deleteParameter = function (key, queryString) {
    if (typeof queryString === 'undefined') {
      queryString = location.search.substring(1);
    }

    var params = queryString.split('&');
    var newUrlQuery = [];

    for (var i = 0; i < params.length; i++) {
      var keyVal = params[i].split('=');

      if (keyVal[0].toLowerCase() !== key.toLowerCase()) {
        newUrlQuery.push(keyVal[0] + '=' + keyVal[1]);
      }
    }

    return newUrlQuery.join('');
  };

  var replaceParameterValue = function (key, val, queryString) {
    if (typeof queryString === 'undefined') {
      queryString = location.search.substring(1);
    }

    var params = queryString.split('&');
    var newUrlQuery = [];

    for (var i = 0; i < params.length; i++) {
      var keyVal = params[i].split('=');

      if (keyVal[0].toLowerCase() === key.toLowerCase()) {
        newUrlQuery.push(keyVal[0] + '=' + val);
      }
    }

    return '?' + newUrlQuery.join('&');
  };

  var appendParameter = function (queryKey, queryValue, url) {
    // if queryString not defined, use current location URL
    if (!url) {
      url = window.location.origin + window.location.pathname + window.location.search;
    }
    var existingParams = url.indexOf('?') > -1;
    url += (existingParams ? '&' : '?') + queryKey + '=' + queryValue;

    return url;
  };

  var assignMethod = Object.assign;

  var formatDate = function (date) {
    return date.toLocaleDateString('da-DK').replace(/\//g, '.') + ' kl. ' + date.toLocaleTimeString('da-DK').replace(/\./g, ':').slice(0, -3);
  };

  var formatDateShort = function (date) {
    return date.getDate() + '/' + (date.getMonth() + 1) + ' kl. ' + date.getHours() + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
  };

  var formatDateOnly = function (date) {
    var day = date.getDate();
    var month = date.getMonth() + 1;
    return (day < 10 ? '0' + day : day) + '-' + (month < 10 ? '0' + month : month) + '-' + date.getFullYear();
  };

  var getPreviousDatesFromToday = function (count, descending = false) {
    const today = new Date();
    let dates = [];

    for (let i = 0; i <= count; i++) {
      const calculatedDate = new Date(new Date().setDate(today.getDate() - i));
      const dateWithoutTime = new Date(calculatedDate.getFullYear(), calculatedDate.getMonth(), calculatedDate.getDate());
      dates.push(dateWithoutTime);
    }

    if (descending) {
      return dates.reverse();
    }

    return dates;
  };

  var formatCurrencyWithoutDecimals = function (amount) {
    if (typeof amount === 'number') {
      amount = amount.toString();
    }

    amount = amount.split('.')[0];
    return formatCurrency(amount);
  };

  var formatCurrency = function (amount) {
    if (typeof amount === 'number') {
      amount = Number(amount).toFixed(2);
    }

    amount = amount.replace('.', ',');
    return amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  };

  var formatInputValue = function (value) {
    var inputValue = value || null;

    // Strip all illegal characters
    if (inputValue) {
      var matches = inputValue.match(/[\d.,]+/gi);
      inputValue = matches ? matches.join('') : '';
    }

    // Replace all commas with period. In order to probably split integer and decimal value.
    inputValue = inputValue.replace(/,/g, '.');

    // Build parts array
    var parts = inputValue.split('.');

    // Handle if the user is trying to add a second decimal point.
    // Example:
    // Input:  15.5. (after split() length is 3)
    // Output: 15.5  (throw away last element)
    if (parts.length > 2) {
      parts = parts.slice(0, 2);
    }

    // Sanitize decimal part of the input. This removes redundant decimal points and constrains decimal part to two digits.
    if (parts[1] && parts[1] !== '') {
      parts[1] = parts[1].replace(/,|\./g, '').slice(0, 2);
    }

    // Finally tie everything together and enforce comma as decimal point.
    return parts.join(',');
  };

  var convertCentsToKroner = function (value) {
    var amount = parseInt(value, 10);
    return amount / 100;
  };

  var convertKronerToCents = function (value) {
    var amount = parseInt(value, 10);
    return amount * 100;
  };

  var convertCentsToKronerAndFormat = function (value) {
    var amount = convertCentsToKroner(value);
    return formatCurrency(amount);
  };

  var scrollToError = function () {

    var error = document.querySelectorAll('.has--error');
    if (error.length > 0) {
      var routeSlide = document.querySelectorAll('.route-slide');
      var elemOffsetY = error[0].offsetTop;
      var isFixed = false;

      if (routeSlide.length) {
        var routeSlideStyle = window.getComputedStyle(routeSlide[0], null);
        isFixed = routeSlideStyle !== null && routeSlideStyle.getPropertyValue('position') === 'fixed';
      }

      const scrollTopPos = elemOffsetY - 50;

      if (isFixed) {
        routeSlide[0].scrollTo({ top: scrollTopPos, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: scrollTopPos, behavior: 'smooth' });
      }
    }
  };

  var fileExtension = function (filename) {
    return filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
  };

  var sortCardsList = function (cardsList) {
    return cardsList.sort(function (a, b) {
      if (a.isPrimaryCard || b.cardExpirationDate.expired) return -1;
      if (b.isPrimaryCard || a.cardExpirationDate.expired) return 1;
      return 0;
    });
  };

  var uniqueParams = function (params) {
    var querySplit = params.split('?');

    if (querySplit.length !== 2) {
      return params;
    }

    var paramsSplit = querySplit[1].split('&');
    var unique = [];

    for (var i = 0; i < paramsSplit.length; i++) {
      var param = paramsSplit[i];

      if (unique.indexOf(param) === -1) {
        unique.push(param);
      }
    }

    return querySplit[0] + '?' + unique.join('&');
  };

  var replaceDynamicText = function (text, replacements) {
    if (typeof replacements !== 'object') {
      return text;
    }

    const replacementKeys = Object.keys(replacements);

    for (var i = 0; i < replacementKeys.length; i++) {
      const key = replacementKeys[i];
      const val = replacements[key];

      text = text.replace(new RegExp('{' + key + '}', 'gi'), val);
    }

    return text;
  };

  const chunks = (inputArray = [], chunkSize = 1) => {
    const result = inputArray.reduce((resultArray, item, index) => {
      const chunkIndex = Math.floor(index / chunkSize);

      if (!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = [];
      }

      resultArray[chunkIndex].push(item);

      return resultArray;
    }, []);

    return result;
  };

  const getPercentageOfSize = (size, totalSize) => {
    if (size <= 0) {
      return 0.5;
    }

    return size / totalSize;
  };

  const sumAllTransactionPeriods = (type, periods = []) => {
    const initialSum = 0;
    const sum = periods.reduce((previousValue, currentPeriod) => {
      return previousValue + currentPeriod[type];
    }, initialSum);

    return sum;
  };

  const isTopFrame = () => {
    return window.self === window.top;
  };

  const calculateAge = (dateString, today) => {
    if (!dateString) return;

    const day = parseInt(dateString.substring(0, 2), 10);
    const month = parseInt(dateString.substring(2, 4), 10) - 1; // JS months are 0-indexed
    const year = parseInt(dateString.substring(4, 6), 10);

    // Set 'today' based on the 'data-time-now' attribute or the current date
    if (!today) {
      const timeNow = document.body.getAttribute('data-time-now');
      today = timeNow ? new Date(timeNow) : new Date();
    }

    // Use the year from 'today' for century calculation
    const century = year > today.getFullYear() % 100 ? 1900 : 2000;
    const birthDate = new Date(century + year, month, day);

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  };

  // Public functions:
  return {
    appendParameter,
    assignMethod,
    calculateAge,
    checkEncodeURI,
    chunks,
    convertCentsToKroner,
    convertCentsToKronerAndFormat,
    convertKronerToCents,
    deleteParameter,
    fileExtension,
    formatCurrency,
    formatCurrencyWithoutDecimals,
    formatDate,
    formatDateOnly,
    formatDateShort,
    formatInputValue,
    getDefaultRedirectUrl,
    getParameter,
    getPercentageOfSize,
    getPreviousDatesFromToday,
    getRedirectUrlWithDsApplicationIdAndReturnUrl,
    getValidAppRedirectUrl,
    hasObjectProperty,
    isApp: Utils.isApp,
    isAppUrl,
    isTopFrame,
    populateUrlWithAssertionIdAndLoginId,
    replaceDynamicText,
    replaceParameterValue,
    repopulateUrlWithAssertionIdAndLoginId,
    scrollToError,
    sortCardsList,
    sumAllTransactionPeriods,
    uniqueParams,
    urlContainsLoginInformation,
  };
});
